import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import './ConfirmationModal.css';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <div className="confirm-modal-header">
          <FaExclamationTriangle className="confirm-modal-icon" />
          <h2>{title || 'Konfirmasi Tindakan'}</h2>
        </div>
        <div className="confirm-modal-body">
          <p>{message || 'Apakah Anda yakin ingin melanjutkan?'}</p>
        </div>
        <div className="confirm-modal-footer">
          <button onClick={onClose} className="cancel-btn">Batal</button>
          <button onClick={onConfirm} className="confirm-btn-delete">Ya, Lanjutkan</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;